import { LOGO_URL } from "@/lib/api";

// Just Peptides product label (matches physical vial labels).
// SVG keeps text crisp at any size; long titles wrap so they never collide with the barcode.
export const ProductLabel = ({ product, className = "", ...rest }) => {
  const name = product.label_name || product.name || "";
  const size = product.size || "";

  // Pick a font size, then wrap the title within the left column (x16 -> x226, width ~210).
  const fs = name.length <= 9 ? 42 : name.length <= 16 ? 30 : 25;
  const budget = Math.max(6, Math.floor(210 / (fs * 0.56)));
  const words = name.split(" ");
  const lines = [];
  let cur = "";
  for (const w of words) {
    const t = cur ? cur + " " + w : w;
    if (t.length <= budget || !cur) cur = t;
    else {
      lines.push(cur);
      cur = w;
    }
  }
  if (cur) lines.push(cur);
  const nameLines = lines.slice(0, 3);

  const lineH = fs * 1.05;
  const firstBaseline = 64 + fs;
  const lastNameY = firstBaseline + (nameLines.length - 1) * lineH;
  const sizeY = lastNameY + 34;

  // Barcode (vertical bars) in the right column.
  const widths = [2, 1, 3, 1, 2, 2, 1, 3, 1, 2, 1, 3, 2, 1, 2, 1, 3, 1, 2, 2, 1, 2];
  const gap = 1.7;
  let bx = 240;
  const bars = widths.map((w) => {
    const r = { x: bx, w };
    bx += w + gap;
    return r;
  });

  return (
    <svg
      viewBox="0 0 360 210"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label={`${name} ${size} label`}
      style={{ fontFamily: '"Clash Display", "Manrope", sans-serif' }}
      {...rest}
    >
      <rect x="0.75" y="0.75" width="358.5" height="208.5" rx="12" fill="#ffffff" stroke="#e5e9ef" strokeWidth="1.5" />

      {/* top row */}
      <text x="16" y="26" fontFamily='"JetBrains Mono", monospace' fontSize="11" fill="#64748b">Batch No: 0325</text>
      <text x="344" y="26" textAnchor="end" fontFamily='"JetBrains Mono", monospace' fontSize="10" fill="#9aa7b5">professional use only</text>

      {/* real brand logo (top-right) */}
      <image href={LOGO_URL} x="232" y="30" width="112" height="60" preserveAspectRatio="xMidYMid meet" />

      {/* barcode (right column, below logo) */}
      {bars.map((b) => (
        <rect key={`bar-${b.x}`} x={b.x} y="104" width={b.w} height="66" fill="#0b1a29" />
      ))}
      <text x="292" y="182" textAnchor="middle" fontFamily='"JetBrains Mono", monospace' fontSize="8" fill="#94a3b8">0 325 00000 0</text>

      {/* title (wrapped) + size (left column) */}
      {nameLines.map((ln, i) => (
        <text key={`ln-${i}-${ln}`} x="16" y={firstBaseline + i * lineH} fontSize={fs} fontWeight="700" fill="#142f4c">{ln}</text>
      ))}
      <text x="16" y={sizeY} fontSize="28" fontWeight="700" fill="#1f7fd4">{size}</text>

      {/* footer */}
      <text x="16" y="198" fontFamily='"JetBrains Mono", monospace' fontSize="9.5" fill="#64748b">
        For Subcutaneous Use Only. Store 36°F–46°F Do not freeze
      </text>
    </svg>
  );
};
